import * as React from "react"

const SMALL_SCREEN_MAX = 1023 // < lg breakpoint (tablet and phones)

export function useIsSmallScreen() {
  const [isSmall, setIsSmall] = React.useState<boolean>(false)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${SMALL_SCREEN_MAX}px)`)
    const onChange = () => setIsSmall(mql.matches)
    onChange()
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isSmall
}
